import React from "react"
import { BackButton } from "../../components/BackButon"
import MiniLoader from "../../components/Loaders/MiniLoader"
import EventNavbar from "../../components/Navbar/EventNavbar"
import { ShoppingCart } from "../../components/shoppingcart"

const ShippingInfo = ({ items, step, submit, loading }) => {
  return (
    <>
      <EventNavbar />
      <div className="global-container py-20">
        <h2 className="font-semibold my-5 px-2">Checkout</h2>
        <div className="flex flex-wrap -mx-2 mb-8">
          <div class="mobiles:w-full w-2/3 lg:w-2/3 px-2 mb-4">
            <div className="hidden mobiles:block mb-3">
              <ShoppingCart items={items} no_of_items={items.length} />
            </div>
            <nav class="flex sm:flex-row">
              <button
                className={`text-gray-400 py-4 px-6 block hover:text-black focus:outline-none focus:text-black ${
                  step === 1 && "border-b "
                } text-xs border-black-400`}
              >
                01 CUSTOMER INFO
              </button>
              <button
                className={`py-4 px-6 block hover:text-black focus:outline-none  ${
                  step === 2 && "border-b border-black text-black"
                } text-xs border-black-400`}
              >
                02 SHIPPING INFO
              </button>
              {/* <button className="text-gray-400 py-4 px-6 block hover:text-blue-500 text-xs focus:outline-none">
                03 PAYMENT SELECTION
              </button> */}
            </nav>

            {/* ====== */}

            <div className="mt-10">
              <h2 className=" my-10 mx-3">Shipping Method</h2>
              <div className="flex flex-wrap">
                <div className="mobiles:w-full w-1/2 lg:w-1/2 px-2 mb-4">
                  <div className="flex text-sm text-grey-dark border py-12 px-5">
                    <div className="w-1/6">
                      <label>
                        <input
                          type="radio"
                          name="radio"
                          value="2"
                          class="mr-2 text-black border-2 border-gray-300 focus:border-gray-300 focus:ring-black"
                        />
                      </label>
                    </div>
                    <div className="w-3/6 text-sm text-gray-500">
                      <h3>Shipping Method</h3>
                      <p className="mt-3">
                        Estimated 14-20 Day Shipping (Duties and taxes may be
                        due upon delivery)
                      </p>
                    </div>
                    <div className="w-2/6">
                      <h3>Free</h3>
                    </div>
                  </div>
                </div>
                <div className="mobiles:w-full w-1/2 lg:w-1/2 px-2 mb-4">
                  <div className="flex text-sm text-grey-dark border py-12 px-5">
                    <div className="w-1/6">
                      <label>
                        <input
                          type="radio"
                          name="radio"
                          value="2"
                          class="mr-2 text-black border-2 border-gray-300 focus:border-gray-300 focus:ring-black"
                        />
                      </label>
                    </div>
                    <div className="w-3/6 text-sm text-gray-500">
                      <h3>Shipping Method</h3>
                      <p className="mt-3">
                        Estimated 14-20 Day Shipping (Duties and taxes may be
                        due upon delivery)
                      </p>
                    </div>
                    <div className="w-2/6">
                      <h3>Free</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-between mt-10">
              {/* <BackButton
                text="Back to Customer Info"
                onClick={() => {
                  back()
                }}
              /> */}
              {loading ? (
                <MiniLoader />
              ) : (
                <button
                  type="submit"
                  className=" px-3 py-3 text-center text-white bg-sbg-light-green font-medium text-xs focus:outline-none"
                  onClick={() => {
                    submit()
                  }}
                >
                  CONTINUE TO PAYMENT
                </button>
              )}
            </div>
          </div>

          <div class="mobiles:w-full w-1/3 lg:w-1/3 px-2 mobiles:hidden">
            <ShoppingCart items={items} no_of_items={items.length} />
          </div>
        </div>
      </div>
    </>
  )
}

export default ShippingInfo
